export default __webpack_public_path__ + "static/media/nico-uchitel-2 copy.ebceca46.png";